import React from 'react';
import { ShadowDOMGame } from '../../../components/ShadowDOMGame';
import { GameKey } from '../../../types/game';

interface HtmlGameWrapperProps {
  gameKey: GameKey;
}

const HtmlGameWrapper: React.FC<HtmlGameWrapperProps> = ({ gameKey }) => {
  return (
    <div className="html-game-wrapper" style={{ width: '100%', height: '100%' }}>
      <ShadowDOMGame 
        gameKey={gameKey}
        onLoad={() => console.log('HTML game loaded successfully')}
        onError={(error) => console.error('HTML game loading failed:', error)}
      />
    </div>
  );
};

export default HtmlGameWrapper;
